import type { FC, ReactNode } from 'react';

import { useDreamComponentsContext } from '@/dreamComponentProvider';

import { getResponsiveImageSources } from './responsiveImageSources';

export type { ResponsiveImageSource, ResponsivePreloadSource } from './responsiveImageSources';
export { getResponsiveImageSources, getResponsivePreloadSources } from './responsiveImageSources';

type PictureElementProps = {
  src?: string;
  breakpoint?: string | number;
  children: ReactNode;
} & React.ComponentProps<'picture'>;

// children should be the base image
export const PictureElement: FC<PictureElementProps> = ({ src, breakpoint, children, ...rest }) => {
  const { responsiveImagesEnabled, responsiveImagesBreakpoints } = useDreamComponentsContext();

  if (!responsiveImagesEnabled || !responsiveImagesBreakpoints || !src) return children;

  let breakPoints = [...responsiveImagesBreakpoints];
  if (typeof breakpoint === 'string' && breakpoint?.endsWith('px')) {
    const width = Number(breakpoint.replace('px', ''));
    if (!Number.isNaN(width)) {
      breakPoints = [...breakPoints, width];
    }
  } else if (typeof breakpoint === 'number') {
    const width = breakpoint;
    if (!Number.isNaN(width)) {
      breakPoints = [...breakPoints, width];
    }
  }

  const sources = getResponsiveImageSources(src, breakPoints);

  return (
    <picture {...rest}>
      {sources.map((source) => (
        <source key={source.media} media={source.media} srcSet={source.url} />
      ))}
      {children}
    </picture>
  );
};
